import { Box, Typography, Divider } from '@mui/material';
import { useEffect, useState } from 'react';

const WEDDING_DATE = new Date('2025-08-02T00:00:00');

function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const difference = WEDDING_DATE.getTime() - now.getTime();

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: 2, sm: 3 },
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {Object.entries(timeLeft).map(([unit, value], index) => (
        <Box key={unit} sx={{ textAlign: 'center', position: 'relative' }}>
          <Typography 
            variant="h4" 
            component="span"
            sx={{
              fontFamily: '"Playfair Display", serif',
              fontWeight: 600,
            }}
          >
            {value.toString().padStart(2, '0')}
          </Typography>
          <Typography 
            variant="caption" 
            display="block" 
            sx={{ 
              textTransform: 'uppercase',
              letterSpacing: 1,
              mt: 0.5,
              fontFamily: '"Open Sans", sans-serif',
            }}
          >
            {unit}
          </Typography>
          {index < 3 && (
            <Divider
              orientation="vertical"
              sx={{
                position: 'absolute',
                right: -16,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '20px',
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}

export default CountdownTimer;
